<script setup lang="ts">
defineProps({
    content: {
        type: Object as () => Section,
        required: true,
    },
});
//f1f5f9
</script>

<template>
    <div class="group relative w-full 3xl:h-[35rem] h-[40rem] overflow-hidden">
        <NuxtImg class="object-cover w-full 3xl:h-[35rem] h-[40rem] group-hover:scale-125 duration-[20s]" :src="content.imageUrl" :alt="content.title" />
        <div class="z-10 absolute inset-0 bg-primary/75" />
        <div class="z-50 absolute inset-0 flex items-center container px-6 sm:px-12">
            <div class="font-extrabold text-6xl text-white">
                <div class="text-2xl font-medium intro-x" v-html="content.postTitle" />
                <div class="uppercase mt-2 intro-x" v-html="content.title" />
                <div class="uppercase mt-4 intro-x" v-html="content.subTitle" />
            </div>
        </div>
        <svg class="editorial" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 24 150 28 " preserveAspectRatio="none">
            <defs>
                <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
            </defs>
            <g class="parallax1"><use xlink:href="#gentle-wave" x="50" y="3" fill="#05365675" /></g>
            <g class="parallax2"><use xlink:href="#gentle-wave" x="50" y="0" fill="#ffffff25" /></g>
            <g class="parallax3"><use xlink:href="#gentle-wave" x="50" y="9" fill="#03446a75" /></g>
            <g class="parallax4"><use xlink:href="#gentle-wave" x="50" y="6" fill="#ffffff" /></g>
        </svg>
    </div>
</template>

<style scoped>
.editorial {
    display: block;
    width: 100%;
    height: 60px;
    max-height: 60px;
    margin: 0;
    z-index: 999;
    bottom: 0;
    position: absolute;
    left: 0px;
    float: left;
}

.parallax1 > use {
    animation: move-forever1 10s linear infinite;
    &:nth-child(1) {
        animation-delay: -2s;
    }
}
.parallax2 > use {
    animation: move-forever2 8s linear infinite;
    &:nth-child(1) {
        animation-delay: -2s;
    }
}
.parallax3 > use {
    animation: move-forever3 6s linear infinite;
    &:nth-child(1) {
        animation-delay: -2s;
    }
}
.parallax4 > use {
    animation: move-forever4 4s linear infinite;
    &:nth-child(1) {
        animation-delay: -2s;
    }
}
@keyframes move-forever1 {
    0% {
        transform: translate(85px, 0%);
    }
    100% {
        transform: translate(-90px, 0%);
    }
}
@keyframes move-forever2 {
    0% {
        transform: translate(-90px, 0%);
    }
    100% {
        transform: translate(85px, 0%);
    }
}
@keyframes move-forever3 {
    0% {
        transform: translate(85px, 0%);
    }
    100% {
        transform: translate(-90px, 0%);
    }
}
@keyframes move-forever4 {
    0% {
        transform: translate(-90px, 0%);
    }
    100% {
        transform: translate(85px, 0%);
    }
}
</style>
